import { baseApi } from '@klp/core/api';
import { generateApiRoute } from '@klp/core/api/helpers';

import { Frontpage } from '../classes';
import type { IFrontpageInput } from '../classes/Frontpage';

export const frontpageApi = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
        getFrontpage: build.query<Frontpage, string | undefined>({
            query: (kundeNummer) => ({
                url: generateApiRoute([
                    'kunde',
                    kundeNummer || '0',
                    'forsidefeed',
                ]),
                method: 'GET',
            }),
            transformResponse: (response: IFrontpageInput): Frontpage => {
                // Use the existing Frontpage class that handles the transformation
                return Frontpage.parseObject(response);
            },
        }),
    }),
});

export const { useGetFrontpageQuery, useLazyGetFrontpageQuery } = frontpageApi;
